import React from "react";

const StatusTabs = ({ counts, activeTab, setActiveTab }) => {
    return (
        <div className="stats-bar">

            <div
                className={`stat-box ${activeTab === "active" ? "active" : ""}`}
                onClick={() => setActiveTab("active")}
            >
                <h3>{counts.active}</h3>
                <p>Active</p>
            </div>

            <div
                className={`stat-box ${activeTab === "completed" ? "active" : ""}`}
                onClick={() => setActiveTab("completed")}
            >
                <h3>{counts.completed}</h3>
                <p>Completed</p>
            </div>

            <div
                className={`stat-box ${activeTab === "total" ? "active" : ""}`}
                onClick={() => setActiveTab("total")}
            >
                <h3>{counts.total}</h3>
                <p>Total</p>
            </div>

        </div>
    );
};

export default StatusTabs;
